<template>
    <section class="relative min-h-screen overflow-hidden bg-black text-white">
        <video
            class="absolute inset-0 h-full w-full object-cover"
            autoplay
            muted
            loop
            playsinline
            preload="auto"
        >
            <source :src="bgVideo" type="video/mp4"/>
        </video>

        <!-- overlays -->
        <div class="absolute inset-0 bg-black/52"></div>
        <div
            class="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,0,0,0.78)_0%,rgba(0,0,0,0.62)_28%,rgba(0,0,0,0.28)_60%,rgba(0,0,0,0.18)_100%)]"
        ></div>
        <div
            class="absolute inset-0 bg-[radial-gradient(circle_at_24%_48%,rgba(255,255,255,0.06),transparent_20%),radial-gradient(circle_at_58%_44%,rgba(255,196,0,0.08),transparent_18%)]"
        ></div>

        <div
            class="container relative z-10 mx-auto flex min-h-screen flex-col px-4 py-4 md:px-6 md:py-6 xl:px-8 max-md:mt-10">

            <!-- content -->
            <div
                class="grid flex-1 grid-cols-1 items-center gap-0 pb-4 md:gap-10 xl:grid-cols-[550px_minmax(0,1fr)] xl:gap-6">
                <!-- left -->
                <div class="relative z-20 xl:pt-6">
                    <h1 class="mb-6 text-2xl font-extrabold leading-[1.04] tracking-[-0.04em] md:text-4xl">
                        Решение автоматизации и продвижения вашего бизнеса
                    </h1>

                    <p class="mb-6 text-sm leading-[1.48] text-white/90 md:text-[18px] xl:text-[17px]">
                        Внедрение высоких технологий, которые помогают оптимизировать бизнес-процессы,
                        сокращать операционные расходы и обеспечивать прозрачность работы команды.
                    </p>

                    <p class="mb-9 text-sm leading-[1.48] text-white/90 md:text-[18px] xl:text-[17px]">
                        Ускоряйте развитие бизнеса и повышайте эффективность за счёт современных цифровых решений.
                    </p>

                    <div @click.prevent="callbackStore.showBaseCallbackPopup({title: 'Получить консультацию', description: 'Получить консультацию'})"
                       class="inline-flex h-[52px] w-full items-center justify-center rounded-xl bg-baseColor px-6 text-[16px] font-bold text-black transition hover:bg-[#e6b000] md:w-auto md:min-w-[226px] cursor-pointer">
                        Получить консультацию
                    </div>
                </div>

                <!-- right -->
                <div class="relative min-w-0 xl:pl-2">
                    <!-- desktop -->
                    <div class="hidden xl:block">
                        <div class="desktop-slider-clip">
                            <div class="pl-[88px]">
                                <div class="w-[calc(100%+420px)]">
                                    <Swiper
                                        class="hero-swiper"
                                        :modules="swiperModules"
                                        :slides-per-view="3.35"
                                        :space-between="24"
                                        :loop="true"
                                        :speed="700"
                                        :autoplay="{
                                            delay: 4500,
                                            disableOnInteraction: false
                                        }"
                                        @swiper="onDesktopSwiper"
                                        @slideChange="onDesktopSlideChange"
                                    >
                                        <SwiperSlide v-for="(item, index) in clonedSlides" :key="`d-${index}`">
                                            <article
                                                class="relative flex items-center rounded-[12px] bg-[#f3f3f3]/95  text-[#333] shadow-sm overflow-hidden"
                                            >
                                                <img
                                                    :src="item.image"
                                                    :alt="item.title"
                                                    class="w-full h-full object-cover"
                                                />

                                                <div class="absolute text-lg px-[30px] bottom-[30px]">
                                                    {{ item.title }}
                                                </div>
                                            </article>
                                        </SwiperSlide>
                                    </Swiper>

                                    <div class="mt-7 flex items-center gap-5 pl-[2px]">
                                        <div class="flex items-center gap-3">
                                            <button
                                                type="button"
                                                class="flex h-[58px] w-[58px] items-center justify-center rounded-full border border-white/20 bg-black/15 text-white transition hover:bg-white/10"
                                                @click="slidePrev"
                                            >
                                                <IconAngleLeft class="h-5 w-5"/>
                                            </button>

                                            <button
                                                type="button"
                                                class="flex h-[58px] w-[58px] items-center justify-center rounded-full border border-white/20 bg-black/15 text-white transition hover:bg-white/10"
                                                @click="slideNext"
                                            >
                                                <IconAngleLeft class="h-5 w-5 rotate-180"/>
                                            </button>
                                        </div>

                                        <div class="flex w-full max-w-[560px] items-center gap-6">
                                            <div class="h-[3px] w-full overflow-hidden rounded-full bg-white/16">
                                                <div
                                                    class="h-full rounded-full bg-baseColor transition-all duration-300"
                                                    :style="{ width: progressWidth }"
                                                ></div>
                                            </div>

                                            <div
                                                class="min-w-[98px] text-right text-[34px] font-extrabold leading-none tracking-[-0.04em]">
                                                {{ displayIndex }} / {{ slides.length }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- mobile / tablet -->
                    <div class="xl:hidden">
                        <Swiper
                            class="hero-swiper-mobile"
                            :modules="swiperModules"
                            :slides-per-view="1.18"
                            :space-between="16"
                            :loop="true"
                            :speed="700"
                            :autoplay="{
            delay: 4500,
            disableOnInteraction: false
        }"
                            :breakpoints="{
            640: {
                slidesPerView: 1.35,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 2.15,
                spaceBetween: 18
            }
        }"
                            @swiper="onMobileSwiper"
                            @slideChange="onMobileSlideChange"
                        >
                            <SwiperSlide v-for="(item, index) in clonedSlides" :key="`m-${index}`">
                                <article
                                    class="relative h-[260px] overflow-hidden rounded-[12px] bg-[#f3f3f3]/95 text-[#333] shadow-sm"
                                >
                                    <img
                                        :src="item.image"
                                        :alt="item.title"
                                        class="h-full w-full object-cover"
                                    />

                                    <div class="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/55 to-transparent"></div>

                                    <div class="absolute bottom-[20px] left-[20px] right-[20px] text-[16px] font-medium leading-[1.35] text-white">
                                        {{ item.title }}
                                    </div>
                                </article>
                            </SwiperSlide>
                        </Swiper>

                        <!-- mobile controls -->
                        <div class="mt-5 flex items-center gap-4">
                            <div class="flex w-full items-center gap-4">
                                <div class="h-[3px] w-full overflow-hidden rounded-full bg-white/16">
                                    <div
                                        class="h-full rounded-full bg-baseColor transition-all duration-300"
                                        :style="{ width: progressWidth }"
                                    ></div>
                                </div>

                                <div class="min-w-[62px] text-right text-[20px] font-extrabold leading-none tracking-[-0.04em]">
                                    {{ displayIndex }} / {{ slides.length }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black/45 to-transparent xl:hidden"></div>
    </section>
</template>

<script>
import logo from '@img/logos/logo_comp.png'
import bgVideo from '@vid/bg.mp4'

import feature1 from '@img/home/feature-1.png'
import feature2 from '@img/home/feature-2.png'
import feature3 from '@img/home/feature-3.png'

import {Swiper, SwiperSlide} from 'swiper/vue'
import {Autoplay} from 'swiper/modules'

import 'swiper/css'
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default {
    name: 'Home',
    components: {
        IconAngleLeft,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            logo,
            bgVideo,
            mobileMenuOpen: false,
            desktopSwiper: null,
            mobileSwiper: null,
            realIndex: 0,
            swiperModules: [Autoplay],
            slides: [
                {
                    title: 'Более 50 интеграций с другими сервисами',
                    image: feature1,
                },
                {
                    title: 'Удобная сквозная аналитика',
                    image: feature2,
                },
                {
                    title: 'Повышение конверсии трафика',
                    image: feature3,
                },
            ],
        }
    },
    computed: {
        clonedSlides() {
            let result = []

            while (result.length < 4) {
                result.push(...this.slides)
            }

            return result
        },
        normalizedIndex() {
            return this.slides.length
                ? this.realIndex % this.slides.length
                : 0
        },
        displayIndex() {
            return this.normalizedIndex + 1
        },
        progressWidth() {
            return `${((this.normalizedIndex + 1) / this.slides.length) * 100}%`
        },
    },
    methods: {
        getIsDesktop() {
            if (typeof window === 'undefined') return true
            return window.innerWidth >= 1280
        },
        getActiveSwiper() {
            return this.getIsDesktop() ? this.desktopSwiper : this.mobileSwiper
        },
        onDesktopSwiper(swiper) {
            this.desktopSwiper = swiper
            if (this.getIsDesktop()) this.updateRealIndex(swiper)
        },
        onMobileSwiper(swiper) {
            this.mobileSwiper = swiper
            if (!this.getIsDesktop()) this.updateRealIndex(swiper)
        },
        updateRealIndex(swiper) {
            this.realIndex = (swiper.realIndex || 0) % this.slides.length
        },
        onDesktopSlideChange(swiper) {
            if (this.getIsDesktop()) this.updateRealIndex(swiper)
        },
        onMobileSlideChange(swiper) {
            if (!this.getIsDesktop()) this.updateRealIndex(swiper)
        },
        slidePrev() {
            const swiper = this.getActiveSwiper()
            if (swiper) swiper.slidePrev()
        },
        slideNext() {
            const swiper = this.getActiveSwiper()
            if (swiper) swiper.slideNext()
        },
    },
    setup() {
        const callbackStore = useCallbackStore();

        return {callbackStore}
    }
}
</script>

<style lang="scss">
.slide-size {
    width: 272px;
    height: 281px;
}

.hero-swiper,
.hero-swiper-mobile {
    overflow: visible;
}

.hero-swiper .swiper-slide,
.hero-swiper-mobile .swiper-slide {
    height: auto;
}

.hero-swiper .swiper-slide article,
.hero-swiper-mobile .swiper-slide article {
    height: 100%;
    transition: opacity 0.3s ease, transform 0.3s ease;
}

/* скрываем только слева, справа оставляем выход за пределы */
.desktop-slider-clip {
    overflow: visible;
    clip-path: inset(0 -500px 0 88px);
    -webkit-clip-path: inset(0 -500px 0 88px);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@media (max-width: 1279px) {
    .hero-swiper-mobile {
        overflow: hidden;
    }
}
</style>
